import { Controller } from '@hotwired/stimulus';
import { t } from '../i18n.js';

export default class extends Controller {
  static targets = ['source', 'status'];

  // navigator.clipboard is only guaranteed in secure/focused contexts, so
  // recipient links (often opened via a shared/proxied preview) fall back to
  // the older select-and-execCommand copy rather than failing silently.
  async copy() {
    const text = this.sourceTarget.value;

    if (navigator.clipboard?.writeText) {
      try {
        await navigator.clipboard.writeText(text);
        this.statusTarget.textContent = t('copy_success', 'Copied!');
        return;
      } catch (error) {
        // fall through to the manual-selection fallback below
      }
    }

    this.statusTarget.textContent = this._fallbackCopy() ? t('copy_success', 'Copied!') : t('copy_failed', 'Copy failed — select the link and copy manually.');
  }

  _fallbackCopy() {
    if (typeof this.sourceTarget.select !== 'function') return false;

    this.sourceTarget.select();
    try {
      return document.execCommand('copy');
    } catch (error) {
      return false;
    }
  }
}
